import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "./style.module.scss";

function SelectPillSkeleton({
  width = 150,
  className,
}: {
  width?: number;
  className?: string;
}) {
  return (
    <div className={classNames(styles.wrap, className)}>
      <Skeleton
        variant="rounded"
        width={width}
        height={34}
        sx={{ borderRadius: "999px" }}
      />
    </div>
  );
}

export default SelectPillSkeleton;
